<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'assign-licenses-add-ssd-serial-dialog.title' | translate}}</h2>

<mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="outline">
            <mat-label>{{'assign-licenses-add-ssd-serial-dialog.serial-label' | translate}}</mat-label>
            <textarea matInput type="text" formControlName="serial" id="pba-serials"></textarea>
        </mat-form-field>
    </form>
    @if (error_occurred) {
        <div class="mat-error">{{error_occurred | translate}}</div>
        @if (badSerials.length > 0) {
            <div class="mat-error dup-serials-list">
                {{ badSerials.join(', ') }}
            </div>
        }
    }
    @if (form.get('serial')?.errors?.duplicateSerials) {
        <div class="mat-error">{{'assign.pba.duplicate-serials-in-input' | translate}}</div>
        <div class="mat-error dup-serials-list">
            @for (dup of form.get('serial')?.errors?.duplicateSerials.duplicates.slice(0, 3); track $index) {
                <div>{{ dup }}</div>
            }
            @if (form.get('serial')?.errors?.duplicateSerials.duplicates.length > 3) {
                <div>{{ 'assign.pba.and-n-more' | translate : {n: form.get('serial')?.errors?.duplicateSerials.duplicates.length - 3} }}</div>
            }
        </div>
    }

</mat-dialog-content>

<div mat-dialog-actions>
    <button mat-raised-button type="button" id="close-button"  (click)="onCancelClick()">{{'H_CLOSE' | translate}}</button>
    <button mat-raised-button type="button" id="save-add-button" (click)="onSaveAndAddAnotherClick()" [disabled]="adding || !form.valid">{{'SAVE_AND_ADD_ANOTHER' | translate}}</button>
    <button mat-raised-button type="button" id="save-button" color="primary" (click)="onSaveClick()" [disabled]="adding || !form.valid">{{'SAVE' | translate}}</button>
</div>
